import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    // Populate the component parts with theme styles
    return {
        container: {
        },

        disabledContainer: {
        },

        outerButton: {
            height: theme.radioButtonSize,
            width: theme.radioButtonSize,
            borderRadius: theme.radioButtonSize / 2,
            borderWidth: theme.radioButtonSelectorBorderWidth,
            borderColor: theme.radioButtonSelectorColorOuter,
        },

        innerButton: {
            height: theme.radioButtonSize / 2,
            width: theme.radioButtonSize / 2,
            borderRadius: theme.radioButtonSize / 4,
            backgroundColor: theme.radioButtonSelectorColorInner,
        },

        text: {
            ...theme.fonts.radioButton,
        },
    };
};

export default getTheme;
